import { T } from "@freightsimple/ui-core/Typography/T";

interface PairMobileDeviceRefreshNoticeProps {
  /** Fade the "New code generated" note in while true, out while false. */
  visible: boolean;
}

/**
 * The transient "New code generated" confirmation. Stays mounted (reserving
 * its line so the layout doesn't jump when it appears) and fades in and out via
 * the opacity transition.
 */
export function PairMobileDeviceRefreshNotice({
  visible,
}: PairMobileDeviceRefreshNoticeProps) {
  return (
    <span
      className={`transition-opacity duration-300 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
      data-testid="pair-mobile-device-regenerated-confirmation"
    >
      <T size="sm" color="green">
        New code generated
      </T>
    </span>
  );
}
